import { CircularProgress } from "@mui/material";

const PageLoader = () => {
  return (
    <div className="fixed top-0 left-0 z-[999] h-screen w-full bg-[rgba(255,255,255,0.6)] flex items-center justify-center">
      <CircularProgress size={50} style={{color:'black'}}/>
    </div>
  )
};

export default PageLoader;
